export default {
  ENT_TOURNAMENT_STATUS_CHANGED: 'statusChanged',
  ENT_WIN_LIMIT_EXCEEDED: 'winLimitExceeded',
  ENT_SYSTEM: 'system',
}
